import { createAsyncThunk } from '@reduxjs/toolkit';
import LocationApi from '~/apis/location';
import {
  CREATE_LOCATION_COMPANY,
  GET_LOCATIONS,
  GET_LOCATION_COMPANY_DETAIL,
  LOCATION_COMPANY_LIST,
  UPDATE_LOCATION_COMPANY,
} from '~/utils/constants/actionType';
import {
  ICreateLocationCompany,
  IParamsGetLocationCompany,
  IParamsLocation,
  IReponseLocationDetail,
  IResponseGetLocationCompany,
  IResponseGetLocations,
} from '~/utils/interface/location';

export const handleGetLocations = createAsyncThunk<IResponseGetLocations, IParamsLocation>(
  GET_LOCATIONS,
  async (params: IParamsLocation, { rejectWithValue }) => {
    try {
      const res = await LocationApi.getLocation(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetLocationsCompany = createAsyncThunk<IResponseGetLocationCompany, IParamsGetLocationCompany>(
  LOCATION_COMPANY_LIST,
  async (params: IParamsGetLocationCompany, { rejectWithValue }) => {
    try {
      const res = await LocationApi.getLocationCompany(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateLocationCompany = createAsyncThunk<null, ICreateLocationCompany>(
  CREATE_LOCATION_COMPANY,
  async (data: ICreateLocationCompany, { rejectWithValue }) => {
    try {
      const res = await LocationApi.createLocation(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetLocationDetail = createAsyncThunk<IReponseLocationDetail, string>(
  GET_LOCATION_COMPANY_DETAIL,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await LocationApi.getLocationDetail(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateLocation = createAsyncThunk<null, { id: string | undefined; data: ICreateLocationCompany }>(
  UPDATE_LOCATION_COMPANY,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await LocationApi.updateLocation(id, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
